module.exports = __webpack_public_path__ + "4bdd221c01a8d76a5fd7a71bce1dec39.MP3";